export default __webpack_public_path__ + "static/media/gallery2.8526f780.jpg";